import { api } from "../../services";
import Swal from "sweetalert2";

const widgets = {
    state: {
      widget: {
        // widget_key: null, // String - ID Base64
        // type: null, // Integer
        // title: null, // String
        // avatar: null, // String
        // welcome: null, // String
        // message: null, // String
        // color: null, // String
        // position: null, // String
        // finished: null, // String
        // configs: [] // String - Longtext
      },
      widgetKey: null,
      widgetConfig: {
        type: 1, // Integer
        widget_key: null, // String - ID Base64
        title: "Meu novo widget", // String
        // avatar: "https://appbee.com.br/wp-content/uploads/2020/02/logo_bee_popup.jpg",
        avatar: null, // String
        welcome: "Olá! Tudo bem? 👋", // String
        message: "Receba agora o contato de um consultor pelo WhatsApp!", // String
        color: "#2e8b57", // String
        position: "right", // String
        finished: "Recebemos seu contato!", // String
        configs: [] // String - Longtext
      },
      data: []
    },
    getters: {},
    mutations: {
      SET_WIDGET(state, payload) {
        state.widget = payload
      },
    },
    actions: {
      getWidget(context, payload) {
        api.get(`/channels/widgets/${payload.id}`).then(response => {
          context.commit("SET_WIDGET", response.data);
        }).catch(error => {
          if (error.response.status === 401) {
            this.dispatch('logoutUser');
          }
        });
      },
      updateWidget(context, payload) {
        const channel_id = payload.channel_id;
        delete payload.channel_id
        api.post(`/channels/widgets/${channel_id}`, payload).then(response => {
          // context.commit("SET_WIDGET", response.data);
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: context.rootGetters.getTranslations('expression_974'),
            showConfirmButton: false,
            timer: 1500
          })
        }).catch(error => {
          if (error.response.status === 401) {
            this.dispatch('logoutUser');
          } else {
            Swal.fire(
              `${ context.rootGetters.getTranslations('expression_406')}`,
              `${error.response.data.message}`,
              'warning'
            )
          }
        });
      },
    },
}
export default widgets;
